module.exports = __webpack_public_path__ + "static/replate-cover-38a72ca8434ab763a38d5dfa7041d003.png";